if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
        this.loading = document.querySelector('cd-loading');
        this.hideErrors = this.dataset.hideErrors === 'true';
      }
      validityData(personalizeForm) {
        const requiredInput = personalizeForm.querySelectorAll('input[required]');
        let result = true;
        if (requiredInput.length) {
          // 检查必填项是否有值；
          result = Array.from(requiredInput).every(item => item.value.length)
        }
        return result;
      }
      async onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        const isMobile = window.matchMedia('(max-width: 768px)').matches;
        const personalizeForm =  document.querySelector('personalize-canvas');
        if(personalizeForm && personalizeForm.children.length && !this.validityData(personalizeForm)) {
          return false;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        const formData = new FormData(this.form);
        let showCartDrawer = true;

        if (this.cart) {
          if (personalizeForm &&  personalizeForm.children.length) {

            const previewFile = personalizeForm.dataset.showType === '1' ? dialogCanvasMergePreview(personalizeForm) : personalizeForm.canvas.previewFile;
            if (previewFile.size>0) {
              let i = 0;
              for (let [key, value] of previewFile) {
                console.log(key, value);
                formData.append(`properties[preview${i ? i : ''}]`, value);
                i++
              }
            }
            showCartDrawer = false;
          }
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        this.loading.show();
        
        for (var pair of formData.entries()) {
          console.log('formData:', pair[0] + ", " + pair[1]);
          if(pair[1].size && pair[1].size > 1024 * 1024) {
            const file = await compressImage(pair[1]);
            formData.set(pair[0], file);
            console.log('file:', file);
          }
        }
       
        config.body = formData;
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });

              this.error = false;
              window.dispatchEvent(new Event('Add_To_Cart_Success'))
              this.dispatchEvent(new Event('AddToCartComplete'));
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            this.loading.hide();
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

function dialogCanvasMergePreview(personalizeForm) {
  const step = personalizeForm.querySelectorAll('personalize-group-step');
  const map = new Map();

  step.forEach((item) => {
    const canvas = item;
    const previewFile = canvas.previewFile;
    if (previewFile) {
      for (let [key, value] of previewFile) {
        console.log(key, value);
        map.set(key, value);
      }
    }
  });
  return map;
}


// 压缩图片函数
function compressImage(file, quality = 0.7, maxWidth = 800, maxHeight = 800) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;

      img.onload = () => {
        let width = img.width;
        let height = img.height;

        // 调整图片的宽高
        if (width > height) {
          if (width > maxWidth) {
            height = Math.round((height * maxWidth) / width);
            width = maxWidth;
          }
        } else {
          if (height > maxHeight) {
            width = Math.round((width * maxHeight) / height);
            height = maxHeight;
          }
        }

        // 创建 canvas
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');

        // 绘制图片到 canvas
        ctx.drawImage(img, 0, 0, width, height);

        // 导出图片并进行压缩
        canvas.toBlob((blob) => {
          resolve(blob);
        }, file.type || 'image/jpeg', quality);
      };

      img.onerror = (error) => {
        reject(error);
      };
    };
  });
}